module.exports = __webpack_public_path__ + "media/images/products-banner-image-5b7b019356f879a3303dda1b15556250.svg";